<mat-list-option
  class="list-item list-item-organisations"
  [value]="data?.id"
  [selected]="!loading && selectedId === data?.id"
>
  <div
    matListIcon
    class="list-item__image list-item__image_large"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_rounded]="loading"
  >
    <tui-avatar
      [src]="data && data.photoId ? (data.photoId | getImageSrc | safe: 'url') : (data?.shortName ?? '' | tuiInitials)"
      [size]="'l'"
      [round]="true"
      [style.background]="
        data && !data.photoId && data.shortName ? (data.shortName | tuiAutoColor) : ('' | tuiAutoColor)
      "
    ></tui-avatar>
  </div>
  <div class="list-item__text-box">
    <h3
      class="list-item__title list-item__title_line list-item__title_line_2"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ data?.shortName }}
    </h3>
    <p
      class="list-item__text list-item__text_grey list-item__text_line list-item__text_line_2"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ data?.businessTypesComplected }}
    </p>
  </div>
</mat-list-option>
